/* Savage Gear — filtros de colección.
   Mejora progresiva: sin JS el formulario se envía y filtra igual. El script
   solo evita la recarga completa y actualiza la grilla en su sitio. */

(() => {
  'use strict';

  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];

  const panel = () => $('[data-sg-filtros]');
  const velo = () => $('[data-sg-filtros-velo]');

  function abrir() {
    panel().dataset.open = 'true';
    velo().dataset.open = 'true';
    document.body.style.overflow = 'hidden';
    $('[data-sg-filtros-abrir]').setAttribute('aria-expanded', 'true');
  }

  function cerrar() {
    panel().dataset.open = 'false';
    velo().dataset.open = 'false';
    document.body.style.overflow = '';
    $('[data-sg-filtros-abrir]').setAttribute('aria-expanded', 'false');
  }

  let peticion = 0;

  async function aplicar(url) {
    const mio = ++peticion;
    const zona = $('[data-sg-resultados]');
    zona.setAttribute('aria-busy', 'true');
    zona.style.opacity = '0.5';

    const r = await fetch(url);
    const doc = new DOMParser().parseFromString(await r.text(), 'text/html');

    // Si el cliente siguió tocando filtros, esta respuesta ya no sirve
    if (mio !== peticion) return;

    const nuevos = doc.querySelector('[data-sg-resultados]');
    if (nuevos) zona.innerHTML = nuevos.innerHTML;

    // Chips, conteo y contadores de cada opción también cambian al filtrar
    ['.sg-chips', '.sg-col__conteo', '[data-sg-form-filtros]'].forEach((sel) => {
      const n = doc.querySelector(sel);
      const a = $(sel);
      if (n && a) a.innerHTML = n.innerHTML;
      else if (n && !a && sel === '.sg-chips') {
        $('.sg-col__bar').insertAdjacentElement('afterend', n);
      } else if (!n && a && sel === '.sg-chips') a.remove();
    });

    zona.removeAttribute('aria-busy');
    zona.style.opacity = '';
    history.replaceState({}, '', url);
    enlazar();
  }

  function urlDelFormulario() {
    const form = $('[data-sg-form-filtros]');
    const params = new URLSearchParams(new FormData(form));
    // Los campos vacíos ensucian la URL y rompen el estado compartible
    [...params.entries()].forEach(([k, v]) => { if (v === '') params.delete(k); });
    const base = location.pathname;
    const q = params.toString();
    return q ? `${base}?${q}` : base;
  }

  function enlazar() {
    const form = $('[data-sg-form-filtros]');
    if (!form) return;

    form.addEventListener('change', (e) => {
      if (e.target.type === 'number') return; // los rangos esperan al blur
      aplicar(urlDelFormulario());
    });

    $$('[data-sg-form-filtros] input[type="number"]').forEach((i) =>
      i.addEventListener('change', () => aplicar(urlDelFormulario()))
    );

    form.addEventListener('submit', (e) => {
      e.preventDefault();
      aplicar(urlDelFormulario());
      cerrar();
    });

    // Los chips se resuelven con su propia URL, sin recargar
    $$('.sg-chip, .sg-chips__limpiar').forEach((a) =>
      a.addEventListener('click', (e) => {
        e.preventDefault();
        aplicar(a.getAttribute('href'));
      })
    );
  }

  function init() {
    if (!$('[data-sg-filtros]')) return;
    $('[data-sg-filtros-abrir]')?.addEventListener('click', abrir);
    $('[data-sg-filtros-cerrar]')?.addEventListener('click', cerrar);
    velo()?.addEventListener('click', cerrar);
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && panel().dataset.open === 'true') cerrar();
    });

    const orden = $('[data-sg-orden] select');
    orden?.addEventListener('change', () => {
      const u = new URL(location.href);
      u.searchParams.set('sort_by', orden.value);
      aplicar(u.pathname + u.search);
    });

    enlazar();
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();
})();
